import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { UserService } from "./services/user.service";
import { DataService } from "./services/data.service";
import { SecurityQuestionService } from "./services/security-question.service";
import { CampaignService } from "./services/campaign.service";
import { ChatService } from "./services/chat.service";
import { AccountService } from "./services/account.service";
import { CookieService } from "ngx-cookie-service";
import { CommunicationService } from "./services/communication.service";
import { InputValidationService } from "./helpers/validators/input-validation.service";
import { FormatimePipe } from "./helpers/pipe/formatime.pipe";
import { BudgetService } from "./services/budget.service";
import { IntermediaryService } from "./services/intermediary-details.service";
import { AppInsightsService } from "./services/appinsights.service";
import { BasicInfoService } from "./services/basic-info.service";
import { BrowserModule } from "@angular/platform-browser";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "src/environments/environment";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { MsalModule } from "@azure/msal-angular";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AuthInterceptor } from "./auth/auth.interceptor";
import { AuthGuard } from "./auth/auth.guard";
import { provideRouter } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { appRoutes } from "./routes";
import { OAuthModule } from "angular-oauth2-oidc";
import { PublicClientApplication } from "@azure/msal-browser";
import { FaqService } from "./services/faq.service";
import { SamlService } from "./services/saml.service";


const isIE = globalThis.navigator.userAgent.indexOf("MSIE ") > -1 || globalThis.navigator.userAgent.indexOf("Trident/") > -1;

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, FormsModule, 
                        ReactiveFormsModule, 
                        NgbModule, 
                        NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }), 
      NgIdleKeepaliveModule.forRoot(), OAuthModule.forRoot({
        resourceServer: {
            allowedUrls: [environment.webApiUrl],
            sendAccessToken: true
        }
    }), ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.enableServiceWorker }), 
    MsalModule.forRoot(new PublicClientApplication({
        auth: {
            clientId: environment.azureAdConfig.authConfig.clientId,
            authority: environment.azureAdConfig.tenant
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: true, // edge,iOS Safari/Chrome compatibility
        },
    }), null, null)),
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
    },
    AuthGuard,
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
    provideHttpClient(),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    UserService,
    DataService,
    SecurityQuestionService,
    CampaignService,
    AccountService,
    CookieService,
    CommunicationService,
    InputValidationService,
    FormatimePipe,
    BudgetService,
    IntermediaryService,
    AppInsightsService,
    BasicInfoService,
    ChatService,
    FaqService,
    SamlService
]
};


